import React from 'react';
import { Select } from 'antd';
import { Param } from '../../cliDataSchema';
import ParamFormItem from './ParamFormItem';

type Props = { param: Param; visibleParams: Param[] };

const Choice = ({ param, visibleParams }: Props) => {
  const [disabled, setDisabled] = React.useState(false);

  const options = param.type.choices.map((choice: string) => ({
    label: choice,
    value: choice,
  }));

  return (
    <ParamFormItem
      param={param}
      disabled={disabled}
      setDisabled={setDisabled}
      visibleParams={visibleParams}
    >
      <Select
        mode={param.multiple ? 'multiple' : undefined}
        allowClear={!param.required}
        disabled={disabled}
        options={options}
      />
    </ParamFormItem>
  );
};

export default Choice;
